module.exports = __webpack_public_path__ + "static/media/tutorial-dr-licita-document.5d3d1e6b.png";